//export const API_URL = 'http://127.0.0.1:8000/api';
//export const API_URL = 'http://192.168.0.108:8000/api';

 

export const API_URL ='https://qrorder.milvendas.ao/api';
